var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCandles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 5.17634H40.3075V1.55103C40.3075 0.90415 39.7825 0.37915 39.1356 0.37915C38.4887 0.37915 37.9637 0.90415 37.9637 1.55103V5.17634H37.8962C36.2162 5.17634 34.8494 6.54321 34.8494 8.22321V31.7948C34.8494 33.4748 36.2162 34.8417 37.8962 34.8417H37.9637V38.467C37.9637 39.1138 38.4887 39.6388 39.1356 39.6388C39.7825 39.6388 40.3075 39.1138 40.3075 38.467V34.8417H40.375C42.055 34.8417 43.4219 33.4748 43.4219 31.7948V8.22321C43.4219 6.54321 42.055 5.17634 40.375 5.17634Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9515 16.5417H28.884V14.7445C28.884 14.0976 28.359 13.5726 27.7122 13.5726C27.0653 13.5726 26.5403 14.0976 26.5403 14.7445V16.5417H26.4728C24.7928 16.5417 23.4259 17.9086 23.4259 19.5886V37.2061C23.4259 38.8861 24.7928 40.2529 26.4728 40.2529H26.5403V42.0501C26.5403 42.697 27.0653 43.222 27.7122 43.222C28.359 43.222 28.884 42.697 28.884 42.0501V40.2529H28.9515C30.6315 40.2529 31.9984 38.8861 31.9984 37.2061V19.5886C31.9984 17.9086 30.6315 16.5417 28.9515 16.5417Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5281 12.6801H17.4606V10.2491C17.4606 9.60227 16.9356 9.07727 16.2887 9.07727C15.6418 9.07727 15.1168 9.60227 15.1168 10.2491V12.6801H15.0493C13.3693 12.6801 12.0024 14.047 12.0024 15.727V26.5223C12.0024 28.2023 13.3693 29.5691 15.0493 29.5691H15.1168V32.0001C15.1168 32.647 15.6418 33.172 16.2887 33.172C16.9356 33.172 17.4606 32.647 17.4606 32.0001V29.5691H17.5281C19.2081 29.5691 20.5749 28.2023 20.5749 26.5223V15.727C20.5749 14.047 19.2081 12.6801 17.5281 12.6801Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10375 5.72665H6.03625V1.55103C6.03625 0.90415 5.51125 0.37915 4.86438 0.37915C4.2175 0.37915 3.6925 0.90415 3.6925 1.55103V5.72665H3.625C1.945 5.72665 0.578125 7.09352 0.578125 8.77352V30.5348C0.578125 32.2148 1.945 33.5816 3.625 33.5816H3.6925V37.7573C3.6925 38.4041 4.2175 38.9291 4.86438 38.9291C5.51125 38.9291 6.03625 38.4041 6.03625 37.7573V33.5816H6.10375C7.78375 33.5816 9.15063 32.2148 9.15063 30.5348V8.77352C9.15063 7.09352 7.78375 5.72665 6.10375 5.72665Z",
    fill: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 39.1356,
    y1: 0.37915,
    x2: 39.1356,
    y2: 39.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 27.7122,
    y1: 13.5726,
    x2: 27.7122,
    y2: 43.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 16.2887,
    y1: 9.07727,
    x2: 16.2887,
    y2: 33.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 4.86438,
    y1: 0.37915,
    x2: 4.86438,
    y2: 38.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0169F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandles);
export default __webpack_public_path__ + "static/media/candles.5f81a481a27479650106423a896ad2b6.svg";
export { ForwardRef as ReactComponent };